(ns frontend.view.grid.screening.columns
  (:require
   [frontend.state.current-session :as session]))

;;default set of selected columns
(def ordered-default-columns
  [:screening-profile/name
   :screening-profile/screening-status
   :screening-profile/sanction-status
   :screening-profile/pep-status
   :screening-profile/latest-pep-status-change
   :screening-profile/external-screening-id
   :screening-profile/latest-pep-status-change
   :screening-profile/refresh-timestamp
   :screening-profile/type
   :screening-profile/company-name
   :screening-profile/first-name
   :screening-profile/last-name
   :screening-profile/country
   :screening-profile/date-of-birth
   :screening-profile/uuid
   :screening-profile/kyc-profile-labels
   :screening-profile/counterparty-diligence-labels
   :screening-profile/business-id
   :screening-profile/pep-or-rca-mismatch])

(def default-columns
  (set ordered-default-columns))

;;always selected:
(def mandatory?
  #{:screening-profile/name})
